import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { Header } from '@/widgets/header'
import styled from 'styled-components'
import { useAuthStore } from './store/authStore'
import { routes } from '@/shared/config/routes'

const LayoutContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`

export const AppLayout: React.FC = () => {
  const { isAuthenticated } = useAuthStore()

  if (!isAuthenticated) {
    return <Navigate to={routes.login} replace />
  }

  return (
    <LayoutContainer>
      <Header />
      <Outlet />
    </LayoutContainer>
  )
}
